import {
  getPartnerExperience,
  type PartnerExperienceConfig,
} from "partners/partnerExperiences";
import { getSelfCampaignQueryParams } from "./queryParams";

type ResolveSelfCampaignPartnerExperienceParams = {
  search: string;
  leadPartner?: string | null;
};

export const resolveSelfCampaignPartnerExperience = ({
  search,
  leadPartner,
}: ResolveSelfCampaignPartnerExperienceParams):
  | PartnerExperienceConfig
  | undefined => {
  const leadPartnerExperience = getPartnerExperience(leadPartner);
  if (leadPartnerExperience) {
    return leadPartnerExperience;
  }

  const queryPartner = getSelfCampaignQueryParams(search).partner;
  const queryPartnerExperience = getPartnerExperience(queryPartner);

  if (queryPartnerExperience) {
    return queryPartnerExperience;
  }

  return undefined;
};
